import type {Media} from './media';

export enum CountryListType {
  FULL_LISTING = 'Full Listing',
  EXTERNAL_REDIRECT = 'External Redirect',
}

export interface CountryCardView {
  uuid: string;
  title: string;
  image: Media;
}

export interface FeaturedProjectView {
  uuid: string;
  name: string;
  paragraphs: string[];
  image: Media;
  externalUrl?: string;
}

export interface CountryDetailView {
  uuid: string;
  name: string;
  type: CountryListType;
  banner: Media;
  features: FeaturedProjectView[];
}
